import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import * as feather from "feather-icons";
import { Subject, combineLatest } from "rxjs";
import { filter, startWith, takeUntil } from "rxjs/operators";
import { LayoutService } from "../../../services/layout.service";
import { NavService } from "../../../services/nav.service";
import { fadeInAnimation } from "../../../data/router-animation/router-animation";
import { SmartAssistantPreferenceService } from "../../../services/smart-assistant-preference.service";

@Component({
  selector: "app-content",
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.scss"],
  animations: [fadeInAnimation],
})
export class ContentComponent implements OnInit, AfterViewInit, OnDestroy {
  showAssistantFab = false;
  private readonly destroy$ = new Subject<void>();
  private isMerchantUser = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public navServices: NavService,
    public layout: LayoutService,
    private assistantPreference: SmartAssistantPreferenceService,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.layout.config.settings.layout = params.layout ? params.layout : this.layout.config.settings.layout;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
    });
  }

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : "";
  }

  get layoutClass() {
    return "compact-wrapper";
  }

  ngOnInit() {
    const rawType = localStorage.getItem("user_type");
    let userType: number | null = null;
    if (rawType) {
      try {
        userType = Number(JSON.parse(rawType));
      } catch {
        userType = Number(rawType);
      }
    }
    this.isMerchantUser = userType === 100 || userType === 101;

    combineLatest([
      this.assistantPreference.visible$,
      this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        startWith(null),
      ),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([visible]) => {
        const onAssistantPage = this.router.url.includes("ai-voice-invoice");
        this.showAssistantFab = this.isMerchantUser && visible && !onAssistantPage;
      });

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe((event) => {
        if (!this.isInvoicesV2CreateUrl(event.urlAfterRedirects)) {
          return;
        }
        this.scrollMainViewToTop();
        requestAnimationFrame(() => this.scrollMainViewToTop());
        setTimeout(() => this.scrollMainViewToTop(), 0);
        setTimeout(() => this.scrollMainViewToTop(), 200);
      });
  }

  private isInvoicesV2CreateUrl(url: string): boolean {
    const path = (url || "").split("?")[0].split("#")[0];
    return /\/invoices-v2\/create$/i.test(path);
  }

  private scrollMainViewToTop(): void {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    document.querySelectorAll(".page-body").forEach((el) => {
      (el as HTMLElement).scrollTop = 0;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
